import { MailRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Box, InputAdornment, Stack, TextField } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { AuthErrorCode } from 'v2/core/services/auth/errors';
import useForgetPassword from 'v2/core/services/auth/useForgetPassword';

interface ForgotPasswordEmailInputProps {
  email: string;
  setEmail: (email: string) => void;
  setIsEmailVerified: (value: boolean) => void;
}

export const ForgotPasswordEmailInput = ({
  email,
  setEmail,
  setIsEmailVerified,
}: ForgotPasswordEmailInputProps) => {
  const [errorMessage, setErrorMessage] = useState('');

  const [sendOtpOnEmail, status] = useForgetPassword({
    email,
    onSuccess: () => {
      setIsEmailVerified(true);
    },
    onError: (err) => {
      if (err.code === AuthErrorCode.UserNotFoundException) {
        setErrorMessage('Cannot send verification code to given email');
        return;
      }
      setErrorMessage(err.message);
    },
  });

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = e;
    setEmail(value);
  };

  return (
    <Box component="form" onSubmit={sendOtpOnEmail}>
      {errorMessage && (
        <Box sx={{ mb: 2 }}>
          <Alert severity="error">{errorMessage}</Alert>
        </Box>
      )}
      <Stack spacing={3}>
        <TextField
          label="Email Address"
          placeholder="Enter email address"
          onChange={handleOnChange}
          type="email"
          name="email"
          value={email}
          required
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MailRounded color="disabled" />
              </InputAdornment>
            ),
          }}
        />
        <LoadingButton
          size="large"
          variant="contained"
          type="submit"
          loading={IsLoading(status)}
          disabled={IsLoading(status)}
        >
          Send Verification Code
        </LoadingButton>
      </Stack>
    </Box>
  );
};
